import React from "react";

const MarketplaceProductsSection = ({
  submitError,
  submitSuccess,
  ricercaFarmaco,
  onFarmacoSearchChange,
  onFarmacoSearchFocus,
  onFarmacoSearchBlur,
  showAdvancedFilters,
  toggleAdvancedFilters,
  filtroFormaFarmaceutica,
  filtroDosaggio,
  onFarmacoFilterChange,
  formeFarmaceutiche,
  dosaggi,
  filteredFarmaci,
  shouldShowFarmaciSuggestions,
  renderFarmacoSuggestionCard,
}) => (
  <div className="card dashboard-marketplace-panel dashboard-marketplace-panel--intro">
    <div className="dashboard-marketplace-hero dashboard-marketplace-hero--inline">
      <div className="dashboard-marketplace-hero__content">
        <span className="dashboard-marketplace-hero__eyebrow">MARKETPLACE</span>
        <h2>Ricevi le migliori offerte per i tuoi farmaci</h2>
        <p>
          Inizia dalla ricerca, aggiungi i prodotti che ti servono e completa la richiesta
          solo alla fine con accesso o registrazione rapida.
        </p>
        <div className="dashboard-marketplace-hero__chips">
          <span className="badge badge-light"><i className="fa fa-search m-r-5"></i>Ricerca immediata</span>
          <span className="badge badge-light"><i className="fa fa-shopping-basket m-r-5"></i>Carrello semplice</span>
          <span className="badge badge-light"><i className="fa fa-shield m-r-5"></i>Invio protetto</span>
        </div>
      </div>
    </div>

    <div className="body dashboard-marketplace-panel__search-body">
      {submitError ? <div className="alert alert-danger">{submitError}</div> : null}
      {submitSuccess ? <div className="alert alert-success">{submitSuccess}</div> : null}

      <div className="dashboard-marketplace-search-hero dashboard-marketplace-search-hero--inline">
        <div className="dashboard-marketplace-search-hero__topline">
          <div className="dashboard-marketplace-search-hero__eyebrow">Cerca farmaco</div>
          <span className="dashboard-marketplace-search-hero__meta">
            {ricercaFarmaco.trim() ? `${filteredFarmaci.length} risultati` : "Digita per iniziare"}
          </span>
        </div>
        <div className="dashboard-marketplace-search-row">
          <div className="input-group m-b-0 dashboard-marketplace-search-hero__input">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Cerca per nome, forma farmaceutica o dosaggio"
              value={ricercaFarmaco}
              onChange={onFarmacoSearchChange}
              onFocus={onFarmacoSearchFocus}
              onBlur={onFarmacoSearchBlur}
            />
          </div>
          <button
            type="button"
            className={`dashboard-marketplace-search-filter-button ${showAdvancedFilters ? "is-open" : ""}`}
            onClick={toggleAdvancedFilters}
            aria-label={showAdvancedFilters ? "Nascondi filtri" : "Mostra filtri"}
            title={showAdvancedFilters ? "Nascondi filtri" : "Mostra filtri"}
          >
            <i className="icon-equalizer"></i>
          </button>
        </div>

        {(filtroFormaFarmaceutica || filtroDosaggio) ? (
          <div className="dashboard-marketplace-filter-pills dashboard-marketplace-filter-pills--compact">
            {filtroFormaFarmaceutica ? (
              <span className="dashboard-marketplace-filter-pill is-active">
                <i className="icon-layers"></i>
                {filtroFormaFarmaceutica}
              </span>
            ) : null}
            {filtroDosaggio ? (
              <span className="dashboard-marketplace-filter-pill is-active">
                <i className="icon-energy"></i>
                {filtroDosaggio}
              </span>
            ) : null}
          </div>
        ) : null}

        {showAdvancedFilters ? (
          <div className="dashboard-marketplace-filter-shell dashboard-marketplace-filter-shell--compact dashboard-marketplace-filter-shell--inline">
            <div className="row clearfix">
              <div className="col-lg-6 col-md-6">
                <div className="dashboard-marketplace-filter-card">
                  <label>Forma farmaceutica</label>
                  <select
                    className="form-control"
                    value={filtroFormaFarmaceutica}
                    onChange={(event) =>
                      onFarmacoFilterChange("filtroFormaFarmaceutica", event.target.value)
                    }
                  >
                    <option value="">Tutte</option>
                    {formeFarmaceutiche.map((forma) => (
                      <option key={forma} value={forma}>
                        {forma}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="dashboard-marketplace-filter-card">
                  <label>Dosaggio</label>
                  <select
                    className="form-control"
                    value={filtroDosaggio}
                    onChange={(event) => onFarmacoFilterChange("filtroDosaggio", event.target.value)}
                  >
                    <option value="">Tutti</option>
                    {dosaggi.map((dosaggio) => (
                      <option key={dosaggio} value={dosaggio}>
                        {dosaggio}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {shouldShowFarmaciSuggestions ? (
        <div className="card dashboard-marketplace-suggestions-shell">
          <div className="body">
            <div className="dashboard-marketplace-suggestions-shell__top">
              <div>
                <span className="badge badge-info-light">Risultati ricerca</span>
              </div>
              <strong>{Math.min(filteredFarmaci.length, 4)} risultati</strong>
            </div>
            <div className="dashboard-marketplace-suggestions-grid">
              {filteredFarmaci.slice(0, 4).map((farmaco) => renderFarmacoSuggestionCard(farmaco))}
            </div>
          </div>
        </div>
      ) : null}

      {!shouldShowFarmaciSuggestions && ricercaFarmaco.trim() && filteredFarmaci.length === 0 ? (
        <div className="alert alert-secondary m-b-0">
          Nessun farmaco trovato per la ricerca inserita.
        </div>
      ) : null}
    </div>
  </div>
);

export default MarketplaceProductsSection;



